export default __webpack_public_path__ + "static/media/Ballroll_00172.d2016502.png";